import { Buffer } from 'buffer';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import serviceWorkerPush from 'app/../serviceWorkerPush';
import { Utils } from 'app/main/components';

const extractSubscription = (subscription: PushSubscription, userUid: string) => {
	const rawKey = subscription.getKey('p256dh');
	const rawAuthSecret = subscription.getKey('auth');

	if (rawKey && rawAuthSecret) {
		const key = Buffer.from(rawKey).toString('base64');
		const authSecret = Buffer.from(rawAuthSecret).toString('base64');

		const { endpoint } = subscription;

		return { key, authSecret, endpoint, userUid };
	}

	return null;
};

export const subscribe = createAsyncThunk<any, void, { state: any }>(
	'pushSubscriptionManager/state/subscribe',
	async (_params, { dispatch, getState }) => {
		return serviceWorkerPush
			.createSubscription()
			.then(subscription => {
				const userUid = getState().user.data.user_uid;
				const requestBody = extractSubscription(subscription, userUid);

				return Utils.executeApi.post({
					url: '/api/notification/push/subscription',
					body: requestBody,
					dispatch,
					successHandler: response => {
						if (response.status === 200) return requestBody;
					},
					errorHandler: err => console.error(err)
				});
			})
			.catch(err => console.error(err));
	}
);

export const unsubscribe = createAsyncThunk<void, void, { state: any }>(
	'pushSubscriptionManager/state/unsubscribe',
	async (_params, { dispatch, getState }) => {
		const subscription = await serviceWorkerPush.getSubscription();
		if (!subscription) return;

		subscription
			.unsubscribe()
			.then(result => {
				Utils.executeApi.delete({
					url: '/api/notification/push/subscription',
					body: {
						UserUid: getState().user.data.user_uid,
						Endpoint: subscription.endpoint
					},
					dispatch,
					successHandler: response => {},
					errorHandler: err => console.error(err)
				});
			})
			.catch(err => console.error(err));
	}
);

export const getExistingSubscription = createAsyncThunk<any>(
	'pushSubscriptionManager/state/getExistingSubscription',
	async () => serviceWorkerPush.getSubscription()
);

const initialState: PushSubscription | null = null;

const pushSubscriptionSlice = createSlice({
	name: 'pushSubscriptionManager/state',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(subscribe.fulfilled, (state, action) => action.payload);
		builder.addCase(unsubscribe.fulfilled, (state, action) => null);
		builder.addCase(getExistingSubscription.fulfilled, (state, action) => action.payload);
	}
});

export default pushSubscriptionSlice.reducer;
